import styled from 'styled-components'

const Label = styled.span`
  position: relative;
  color: ${props => (props.color ? props.color : '#707070 ')};
  font-weight: 600;
  font-size: 12px;

  letter-spacing: 0.01em;
  ${props => props.labelStyle || ''}
  ${props =>
    props.required &&
    `&::after {
      content: '';
      border-radius: 50%;
      height: 4px;
      width: 4px;
      position: absolute;
      top: 8px;
      margin-left:5px;
      padding-left:2px;
  }`}
  span {
    font-weight: 400;
  }
  ${props => props.marginTop && `margin-top: ${props.marginTop}`}
`
export default Label
